<template>
    <div class="labels">
        <div class="labels__items">
            <div class="labels__item" v-for="(label, index) in displayedLabels" :key="index">
                {{ label.name ? label.name : label.label.name }}
                <span v-if="$can('add', 'Labels')" class="labels__item__remove icon icon--common-x" @click="removeLabelHandler(label, $event)"></span>
            </div>
        </div>
        <div class="labels__right">
            <div v-if="$can('add', 'Labels')" class="labels__add" @click="addLabelHandler">+</div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';

export default {
    props: {
        system: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            systemLabels: false,
        };
    },
    computed: {
        systemOrganizations() {
            if (!this.system.service_organization) return false;
            let organizations = [
                {
                    id: this.system.service_organization.id,
                    name: this.system.service_organization.name,
                },
            ];
            if (this.system.service_organization.breadcrumbs) {
                organizations = [...organizations, ...this.system.service_organization.breadcrumbs];
            }
            return organizations;
        },
        displayedLabels() {
            if (this.systemLabels) return this.systemLabels;
            return this.system.labels;
        },
    },
    methods: {
        addLabelHandler(e) {
            e.preventDefault();
            e.stopPropagation();
            this.$modal.show(
                () => import('@/views/modal/AddLabel.vue'),
                {
                    systemId: this.system.id,
                    organizations: this.systemOrganizations,
                },
                {
                    name: 'AddLabel',
                    scrollable: true,
                    width: 450,
                    height: 'auto',
                    class: 'ngdialog-theme-winconnect',
                },
                {
                    'before-close': () => {
                        this.fetchSystemLabels();
                    },
                }
            );
        },
        removeLabelHandler(label, e) {
            e.preventDefault();
            e.stopPropagation();

            this.$modal.show(
                () => import('@/views/modal/ConfirmDeletion.vue'),
                {
                    text: this.$t('labels.delete_label_text'),
                    cancelText: this.$t('buttons.cancel'),
                    confirmText: this.$t('buttons.delete'),
                    successCallback: () => {
                        this.removeLabel(label);
                    },
                },
                {
                    name: 'ConfirmDeletion',
                    scrollable: true,
                    width: 450,
                    height: 'auto',
                    class: 'ngdialog-theme-winconnect',
                }
            );
        },
        async removeLabel(label) {
            try {
                const response = await api.labels.remove(this.system.id, label.id);
                if (response) {
                    this.fetchSystemLabels();
                    this.$notify({
                        type: 'success',
                        text: this.$t('labels.success_delete_label'),
                    });
                }
            } catch (error) {
                console.error(error);
                this.$notify({
                    type: 'error',
                    text: this.$t('labels.error_delete_label'),
                });
            }
        },
        async fetchSystemLabels() {
            try {
                const response = await api.labels.systemLabels(this.system.id);
                this.systemLabels = response.data.labels;
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>

<style lang="scss">
.labels {
    display: flex;
    align-items: center;
    width: 100%;

    &__items {
        display: flex;
        flex-wrap: wrap;
        margin-top: -5px;
    }

    &__item {
        display: flex;
        align-items: center;
        height: 20px;
        padding: 0 10px;
        background: $color-gray;
        color: white;
        font-size: 12px;
        line-height: 0.8;
        border-radius: 20px;
        margin-right: 5px;
        margin-top: 5px;

        &__remove {
            display: flex;
            margin-left: 6px;
            font-size: 8px;
            line-height: 0;
            margin-right: -2px;
        }
    }
    &__right {
        .table__row & {
            margin-left: auto;
            opacity: 0;
            transition: opacity 200ms ease-out;
        }
    }
    &__add {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 20px;
        height: 20px;
        background: $color-accent;
        border-radius: 100%;
        color: white;
        font-weight: bold;
        border: 1px solid $color-accent;
        transition: all 200ms ease-out;
        cursor: pointer;

        @media (hover: hover) {
            &:hover {
                background: transparent;
                color: $color-accent;
            }
        }
    }
}
</style>
